import axios from "axios";

export const getDataTable = async (service, initialDataCache, headerBaseDataCache, articles) => {
  const articlesIds = articles.map((article) => article.id_article);
  const versions = articles.map((article) => article.version);
  const params = `?articles=${articlesIds.join(",")}&versions=${versions.join(",")}`;

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_MULTIPLE_EDITION_ENDPOINT}/${service}${params}`,
      {
        headers: {
          Authorization: sessionStorage.getItem("jwt"),
        },
      }
    );

    const data = JSON.parse(response.data.body).data;
    const articlesArray = Object.values(data);

    let initialData = initialDataCache && initialDataCache.length > 0 ? initialDataCache : [];
    let headerBaseData = headerBaseDataCache && headerBaseDataCache.length > 0 ? headerBaseDataCache : [];

    if (initialData.length === 0 || headerBaseData.length === 0) {
      initialData = articlesArray.map((item) => ({
        articleId: item.id,
        upc: item.upc,
        name: item.name,
        category: item.category,
        version: item.version,
        retailers: item.retailer ? item.retailer.map((retailer) => retailer.name) : [],
      }));

      headerBaseData = [
        { Header: "UPC", accessor: "upc", width: "150px", fixedToLeft: 0 },
        { Header: "Nombre", accessor: "name", width: "100px", fixedToLeft: 150 },
        { Header: "Categoría", accessor: "category", width: "120px", fixedToLeft: 250 },
        { Header: "Ver.", accessor: "version", width: "50px", fixedToLeft: 300 },
        { Header: "Cadenas", accessor: "retailers", width: "100px", fixedToLeft: 400 },
      ];
    }

    let descriptionsData = [];
    let headerSectionData = [];

    if (service === "description") {
      descriptionsData = articlesArray.map((item) => ({
        articleId: item.id,
        dataAttributes: Object.values(item.descriptions || {}).map((dataAttr) => ({
            id_attribute: dataAttr.attributeId,
            required: dataAttr.required,
            description: dataAttr.description,
            name_attribute: dataAttr.name,
            min_chars: dataAttr.min_chars,
            max_chars: dataAttr.max_chars,
            type: dataAttr.type,
            value: dataAttr.value,
            isApproved: dataAttr.isApproved,
            comment: dataAttr.comment,
            order_sheet: dataAttr.orderSheet,
            sheet_name: dataAttr.sheetName,
          }))
          .sort((a, b) => (a.order_sheet || 0) - (b.order_sheet || 0)),
      }));

      const sortedDescriptions = articlesArray.flatMap((article) =>
        Object.values(article.descriptions || {}).sort(
          (a, b) => (a.orderSheet || 0) - (b.orderSheet || 0),
        ),
      );

      const headerSet = new Set();
      headerSectionData = sortedDescriptions
        .filter((description) => {
          if (headerSet.has(description.attributeId)) {
            return false; // Ya existe, no lo agregamos
          } else {
            headerSet.add(description.attributeId);
            return true; // No existe, lo agregamos
          }
        })
        .map((description) => ({
          Header: description.name,
          accessor: "textArea",
          id_attribute: description.attributeId,
        })
      );
    } else if (service === "datasheet") {
      const datasheetsData = articlesArray.map((item) => {
        const transformedAttributes = Object.values(item.attributes || {}).map((attribute) => ({
          ...attribute,
          id_attribute: attribute.attributeId,
          name_attribute: attribute.name,
        }));

        const groupedBySheet = transformedAttributes.reduce((acc, attr) => {
          const sheetName = attr.sheet_name || "Sin Nombre";
          if (!acc[sheetName]) acc[sheetName] = [];
          acc[sheetName].push(attr);
          return acc;
        }, {});

        const flatAttributes = Object.values(groupedBySheet)
          .flat()
          .sort((a, b) => {
            const getApprovalSortValue = (item) => {
              if (item.isApproved === 0) return 0;
              return 1;
            };

            const approvalSortA = getApprovalSortValue(a);
            const approvalSortB = getApprovalSortValue(b);

            if (approvalSortA !== approvalSortB) {
              return approvalSortA - approvalSortB;
            }

            if (a.sheet_name === "Formato ABC" && b.sheet_name !== "Formato ABC") return -1;
            if (a.sheet_name !== "Formato ABC" && b.sheet_name === "Formato ABC") return 1;
            if (a.sheet_name !== b.sheet_name) {
              return (a.sheet_name || "").localeCompare(b.sheet_name || "");
            }

            return (a.orderSheet || 0) - (b.orderSheet || 0);
          });

        const finalAttributesWithIndex = flatAttributes.map((attr, index) => ({
          ...attr,
          finalOrderIndex: index + 1
        }));

        return {
          item,
          articleId: item.id,
          groupedAttributes: groupedBySheet,
          dataAttributes: finalAttributesWithIndex
        };
      });

      const headerSet = new Set();
      headerSectionData = articlesArray.flatMap((article) =>
        Object.values(article.attributes || {})
          .filter((attribute) => {
            if (headerSet.has(attribute.attributeId)) {
              return false; // Ya existe, no lo agregamos
            } else {
              headerSet.add(attribute.attributeId);
              return true; // No existe, lo agregamos
            }
          })
          .map((attribute) => ({
            Header: attribute.name,
            accessor: "customField",
            id_attribute: attribute.attributeId,
          }))
      );

      descriptionsData = datasheetsData;
    } else {
      // Caso de Imágenes
      const typesData = JSON.parse(response.data.body).typesShot || [];

      const imagesData = articlesArray.map((item) => {
        const currentImages = Object.values(item.images || {});

        return {
          articleId: item.id,
          dataAttributes: typesData
            .filter((attribute) => {
              const relatedImage = currentImages.find(
                (image) => image.imageId === attribute.id
              );
              return !!relatedImage?.value || attribute.mandatory === 1;
            })
            .map((attribute) => {
              const relatedImage = currentImages.find(
                (image) => image.imageId === attribute.id
              );

              return {
                id_attribute: attribute.id,
                categoryId: attribute.categoryId,
                comment: relatedImage?.value?.comment,
                lastModified: relatedImage?.value?.lastModified,
                packingType: relatedImage?.value?.packingType,
                imageType: relatedImage?.value?.imageType,
                src: relatedImage?.value?.src,
                width: relatedImage?.value?.width,
                height: relatedImage?.value?.height,
                required: attribute.mandatory,
                name_attribute: attribute.name,
                commercialModel: attribute.commercialModel,
                type: attribute.type,
                isApproved: relatedImage?.value?.isApproved,
              };
            }),
        };
      });

      if (imagesData.length > 0 && imagesData[0].dataAttributes.length > 0) {
        headerSectionData = imagesData[0].dataAttributes.map((type) => ({
          Header: type.name_attribute,
          accessor: "imageVisor",
          id_attribute: type.id_attribute,
          width: "150px",
        }));
      }

      descriptionsData = imagesData;
    }

    return {
      initialData,
      descriptionsData,
      headerBaseData,
      headerSectionData,
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return {
      initialData: [],
      descriptionsData: [],
      headerBaseData: [],
      headerSectionData: [],
    };
  }
};

export const updateData = async (userId, service, articleId, version, articlesData) => {
  const servicesUrls = {
    description: process.env.REACT_APP_ARTICLE_DESCRIPTION_UPDATE_ENDPOINT,
    datasheet: process.env.REACT_APP_ARTICLE_DATASHEET_UPDATE_ENDPOINT,
    images: process.env.REACT_APP_ARTICLE_IMAGES_UPDATE_ENDPOINT,
  };

  const url = servicesUrls[service];

  const actualData = articlesData.map((article) => ({
    articleId: article.articleId,
    versionId: 1,
    articleData: article.articleData.map((attribute) => ({
      attributeId: attribute.id_attribute,
      value: attribute.value,
      isApproved: attribute.isApproved,
      comment: attribute.comment ?? "",
    })),
  }));

  const jsonPayload = {
    data: actualData,
  };

  try {
    const method = service === "images" ? "put" : "post";

    console.log("url", url);

    const response = await axios.put(`${url}`, jsonPayload, {
      headers: {
        Authorization: sessionStorage.getItem("jwt"),
      },
    });

    if (response.status === 200) {
      return {
        success: true,
        message: `Datos enviados correctamente: ${response.data.message}`,
      };
    } else {
      return {
        success: false,
        message: `Error en la solicitud: ${response.statusText}`,
      };
    }
  } catch (error) {
    console.error("Error en la solicitud:", error);
    return {
      success: false,
      message: `Error en la solicitud: ${error.message}`,
    };
  }
};
